import * as Yup from 'yup';
import { formikRequired } from '../../SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    reason: formikRequired,
  });

export default Validator;
